import styled from "styled-components"

export const HeaderOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  backdrop-filter: blur(5px);
  background: linear-gradient(
    180deg,
    rgba(0, 55, 63, 0.36) 0%,
    rgba(0, 55, 63, 0.18) 100%
  );
  border-bottom: 1px solid rgba(255, 255, 255, 0.4);
  padding: 0 16px 12px;
`

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  padding-left: 0;
  padding-right: 16px;
`

export const CloseButton = styled.button`
  min-width: 44px;
  min-height: 44px;
  padding: 10px 16px 10px 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-tap-highlight-color: transparent;

  &:active {
    opacity: 0.7;
  }
`

export const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 8px;
`

export const TitleContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
`

export const Title = styled.h1`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  color: #ffffff;
  text-align: left;
`

export const SubtitleContainer = styled.div`
  display: flex;
  align-items: baseline;
  gap: 3px;
  font-size: 14px;
  line-height: 14px;
  color: rgba(255, 255, 255, 0.8);
`

export const SubtitleText = styled.span`
  font-weight: 400;
  white-space: nowrap;
`

export const AnimatedTextContainer = styled.div`
  height: 22px;
  overflow: hidden;
  position: relative;
  width: fit-content;
  max-width: 120px;
`

export const AnimatedTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  animation: slideText 7.68s linear infinite;

  @keyframes slideText {
    0% {
      transform: translateY(0);
    }
    18.75% {
      transform: translateY(0);
    }
    25% {
      transform: translateY(-32px);
    }
    43.75% {
      transform: translateY(-32px);
    }
    50% {
      transform: translateY(-64px);
    }
    68.75% {
      transform: translateY(-64px);
    }
    75% {
      transform: translateY(-96px);
    }
    93.75% {
      transform: translateY(-96px);
    }
    100% {
      transform: translateY(-128px);
    }
  }
`

export const AnimatedTextItem = styled.span`
  background: rgba(0, 38, 58, 0.32);
  padding: 0px 8px;
  border-radius: 100px;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  white-space: nowrap;
  display: inline-block;
  align-self: flex-start;
  height: 22px;
  line-height: 22px;
`

export const BetaItem = styled(AnimatedTextItem)`
  border-radius: 100px;
  border: 1px solid
    var(--Schemes-Primary-container-Primary-Container-Variant, #cceded);
  background: var(--Primitive-White, #fff);

  font-size: 12px;
  color: var(
    --Schemes-Primary-container-On-Primary-Container-On-Primary-Container,
    #023648
  );
`
